import { SelectSearchOption } from 'react-select-search';
import CopyAggregationModalState from './CopyAggregationFieldModalState';
import DataSourceField from '../../../../types/report/DataSourceField';
import FieldDefinition from '../../../../types/common/FieldDefinition';
import ReportVariable from '../../../../types/report/ReportVariable';

const getDefaultState = (): CopyAggregationModalState => {
    return {
        title: '',
        isOpen: false,
        error: null,
        sourceNumber: '',
        targetNumbers: new Set(),
        sourceFieldId: '',
        targetFieldId: '',
        copyAllFields: false
    };
};

const createFieldOption = (field: DataSourceField, fieldDefinitions?: FieldDefinition[], variables?: ReportVariable[]): SelectSearchOption => {

    if (field.fieldId) {
        return {
            name: fieldDefinitions ? fieldDefinitions.find(x => x.id === field.fieldId)?.name || '' : '',
            value: `f_${field.fieldId}`

        };
    }
    else if (field.variableNumber) {
        return {
            name: variables ? variables.find(x => x.number === field.variableNumber)?.name || '' : '',
            value: `v_${field.variableNumber}`
        };
    }
    else {
        throw new Error('Field must have either fieldId or variableNumber');
    }
};

const createEmptyFieldOption = (): SelectSearchOption => {
    return {
        name: '',
        value: ''
    };
};

export { getDefaultState, createFieldOption, createEmptyFieldOption };
